import React from "react";

export default function CollegeInfo() {
  return <div>О колледже</div>;
}
